<template>
    <div class="faq-category-question">


        <div class="faq-category grid-item-content">
            <div class="component-title">
                <h5 class="title">{{faqCategoryIn.name}}</h5>
            </div>

            <div class="not-found empty-faq-question-list" v-if="faqCategoryIn.question_answers.length === 0">
                <p class="alert-notice">{{$t('faq.no_questions_found_in_this_category')}}</p>
            </div>


        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-faq-category-component",
    props: {
        faqCategoryIn: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
        }
    },
}
</script>

<style scoped lang="scss">
    .grid-item {
        width: calc(33.333% - 15px);
    }

    .faq-category-wrapper {
        margin-bottom: $grid-gutter-width;
    }

    .faq-category {
        display: flex;
        flex-direction: column;
        row-gap: map-get($grid-gutter-spacing, 'five');
        padding: map-get($grid-gutter-spacing, 'fifteen');
        border-radius: $border-radius-content;
        border: 1px solid $border-color;
        height: 100%;

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
        }
    }

    .component-title {
         margin-bottom: 0;
     }

    .empty-faq-question-list {
        align-items: flex-start;
        padding: map-get($grid-gutter-spacing, 'eight');

        .alert-notice {
            font-size: $base-font-size;
            color: $text-color;
        }
    }
</style>
